const getRadioYesNo = (value: boolean | string | undefined | null) => {
  if (value === undefined || value === null || value === '') return '';
  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }
  return value;
};

export default getRadioYesNo;
